export const ASSET_NAME = 'privacy-policy';

// Attorney Privacy Policy is local. Do not fetch Console stubs.
export const loadData = () => () => Promise.resolve();
